import { render, staticRenderFns } from "./DataHeader.vue?vue&type=template&id=2f7fabfa&scoped=true&"
import script from "./DataHeader.vue?vue&type=script&lang=js&"
export * from "./DataHeader.vue?vue&type=script&lang=js&"
import style0 from "./DataHeader.vue?vue&type=style&index=0&id=2f7fabfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7fabfa",
  null
  
)

export default component.exports